import { ConstantesService } from './../../shared/services/constantes.service';
import { ConfirmationModalOptions } from './../../shared/models/modal.model';
import { GlobalService } from './../../shared/global.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from './../../shared/services/alert.service';
import { OnInit, Component, Input, OnDestroy } from '@angular/core';
import { InformacionVisitanteModel } from 'src/app/shared/models/informacionVisitante.model';
import { UrlService } from 'src/app/shared/services/url.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistroSalidaModalComponent } from './registro-salida-modal.component';
import { ReporteVisitaModel } from 'src/app/models/reporteVisita.model';
import { ContenedorActivoFijoVisitanteModel } from 'src/app/models/contenedorActivoFijoVisitante.model';
import { HisActivoFijoVisitanteModel, HisActivoFijoVisitantePK } from 'src/app/models/hisActivoFijoVisitante.model';
import { ActivoFijoVisitanteModel } from 'src/app/models/activoFijoVisitante.model';
import { ConsultaActivoFijoVisitante } from 'src/app/models/consultaActivoFijoVisitante.model';
import { ActivoFijoModel } from 'src/app/models/activoFijo.model';
import { ParametrosConsultaActivoFijoVisitante } from 'src/app/models/parametrosConsultaActivoFijoVisitante.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { Subscription } from 'rxjs';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';



@Component({
  selector: 'app-registro-salida-visitante',
  templateUrl: './registro-salida-visitante.component.html',
  styleUrls: ['./registro-salida-visitante.component.scss']
})
export class RegistroSalidaVisitanteComponent implements OnInit, OnDestroy {
  public objetoFichaVisitante: InformacionVisitanteModel;
  public objetoEntrada: ReporteVisitaModel;
  public tieneActivosIngresados: boolean;
  public ingresoActivo: boolean;
  public registroFinalizado: boolean;
  public tieneVariasAgendas: boolean;
  public modalOptionsSalida: ConfirmationModalOptions;
  public modalOptionsParcial: ConfirmationModalOptions;
  public modalOptionsSinAct: ConfirmationModalOptions;
  public modalOptionsSinAct2: ConfirmationModalOptions;
  private fechaConsulta: string;
  public banderaMensaje: boolean;

  public parametrosConsultaActivoFijoVisitante: ParametrosConsultaActivoFijoVisitante;
  public consultaActivoFijoVisitante: ConsultaActivoFijoVisitante[] = [];
  public listaActivosPrincipal: ActivoFijoModel[];
  public pantalla: string;
  public subscription: Subscription[] = [];

  constructor(
    private urlService: UrlService, private spiner: NgxSpinnerService
    , private alertService: AlertService, private global: GlobalService
    , private router: Router, private modalService: NgbModal, private route: ActivatedRoute) {

    this.objetoFichaVisitante = new InformacionVisitanteModel('', '', '', '', '', false, '', '', '', false, 'Salida', [], '');
    this.registroFinalizado = false;
    this.pantalla = ConstantesService.PANTALLA_INGRESO_SALIDA_VISITANTE_SALIDA;
    // this.objetoEntrada = { tipoDocumento: null, numeroDocumento: '798045057', fechaAgenda: null };

    this.objetoEntrada = this.global.zonaCompartida[VariablesZonaCompartida.OBJETO_VISITA];

    // se construye la fecha
    if (this.objetoEntrada.agendaVisita) {
      this.fechaConsulta = this.objetoEntrada.agendaVisita.split(' ')[0];
      const fecha = this.fechaConsulta.split('/');
      this.fechaConsulta = fecha[0] + '/' + fecha[1] + '/' + fecha[2];
    }

    this.tieneActivosIngresados = false;
    this.tieneVariasAgendas = false;
    // opciones del modal de confirmación
    this.modalOptionsSalida =
      new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONFIRM_REGISTRO_SALIDA,
        'SI', 'NO', 'fas fa-sign-out-alt', false, false, 'Registrar Salida', null, 'btn-secondary pull-left');
    this.modalOptionsParcial =
      new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONFIRM_REGISTRO_SAL_PARCIAL,
        'SI', 'NO', 'fas fa-sign-out-alt', false, false, 'Registrar Salida Parcial', null, 'btn-secondary pull-right');
    this.modalOptionsSinAct =
      new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONF_RGISTR_SAL_PARCIAL_SIN_ACTIV,
        'SI', 'NO', 'fas fa-sign-out-alt', false, false, 'Registrar Salida Parcial', null, 'btn-secondary pull-right');
    this.modalOptionsSinAct2 =
      new ConfirmationModalOptions('Confirmación', ConstantesService.MSJ_CONF_RGISTR_SAL_PARCIAL_SIN_ACTIV,
        'SI', 'NO', 'fas fa-sign-out-alt', false, false, 'Registrar Salida', null, 'btn-secondary pull-left');
    this.getInformacionVisitante();
  }

  ngOnInit() {

    this.parametrosConsultaActivoFijoVisitante = new ParametrosConsultaActivoFijoVisitante();
  }

  /**
   * Destruye las peticione spendientes de respuesta cuando se destruye el ocmponente
   */
  ngOnDestroy() {
    this.subscription.forEach(sub => {
      sub.unsubscribe();
    })
  }

  /**
   * @author fromero
   * metodo de redirección a página de consultas
   */
  regresarListaAgendas() {
    this.global.zonaCompartida[VariablesZonaCompartida.OBJETO_VISITA] = undefined;
    this.router.navigate(['main/']);
  }

  /**
   * @author fromero
   * método de consulta de información de visitante Básica y agendas del día
   */
  getInformacionVisitante() {
    this.spiner.show();
    const serviceProvider = 'ObetenerInformacionAgendasVisitante';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['tipoDocumento', this.objetoEntrada.tipoIdVisitante]);
    queryParams.push(['numeroDocumento', this.objetoEntrada.numeroIdVisitante]);
    queryParams.push(['fechaConsulta', this.fechaConsulta]);


    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    const sub = this.global.postGenerico(url).subscribe(
      data => {

        this.objetoFichaVisitante = data[0];
        this.objetoFichaVisitante.numeroDocumento = this.objetoEntrada.numeroIdVisitante;
        this.objetoFichaVisitante.pantalla = 'Salida';

        if (this.objetoFichaVisitante.listaVisitas.length > 1) {
          this.tieneVariasAgendas = true;
        } else {
          this.tieneVariasAgendas = false;
        }
        this.spiner.hide();
        this.consultarActivosFijos();
      }, err => {
        this.cathException(err);
      }
    );
    this.subscription.push(sub);
  }

  /**
  * @author damunoz
  *   metodo que obtiene el elemento seleccionado para registro desde el componente hijo de activos recientes
  * @param event 
  */
  handlerActivoSeleccionado(event) {
    const activoFijoVisitanteDTO = new ActivoFijoVisitanteModel();
    const activoPK = new HisActivoFijoVisitantePK();
    const hisActivoFijoVisitanteDTO = new HisActivoFijoVisitanteModel(activoPK);
    const resp: ContenedorActivoFijoVisitanteModel =
      new ContenedorActivoFijoVisitanteModel(activoFijoVisitanteDTO, hisActivoFijoVisitanteDTO);
    if (event) {
      // mapeo para actualizacion de activo fijo
      resp.activoFijoVisitanteDTO.idActivoFijoVisitante = event.Activo.idActivo;
      resp.activoFijoVisitanteDTO.estado = DominiosService.ESTADO_ACTIVO_FIJO_RETIRADO;
      // creacion de nuevo historico de activo fijo
      resp.hisActivoFijoVisitanteDTO.hisActivoFijoVisitantePK.fechaIngresoActivo = new Date(event.Activo.fechaUltimoIngreso);
      resp.hisActivoFijoVisitanteDTO.hisActivoFijoVisitantePK.idActivoFijoVisitante = event.Activo.idActivo;
      resp.hisActivoFijoVisitanteDTO.sede = event.Activo.sede;
    }
    this.registrarActivoFijoVisitante(resp);
  }

  /**
   * Metodo que registra un nuevo activo fijo de un visitante.
   * @author damunoz
   * @param event 
   */
  registrarActivoFijoVisitante(event: ContenedorActivoFijoVisitanteModel) {
    this.spiner.show();
    const serviceProvider = 'registrarActivoFijoVisitante';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
    const sub = this.global.postGenerico(url, event).subscribe(
      data => {
        this.alertService.generateAlertSuccess(ConstantesService.REGISTRO_ACTIVO_FIJO_VISITANTE_EXISTOSO, '', '');
        this.consultarActivosFijos();
        this.spiner.hide();
      }, (err: any) => {
        this.cathException('No es posible realizar el registro de activo fijo', err);
      }
    );
    this.subscription.push(sub);
  }


  /**
   * Método para obtener activos fijos de un visitante
   * @author damunoz
   */
  public consultarActivosFijos() {
    this.listaActivosPrincipal = [];
    this.tieneActivosIngresados = false;
    const listaTemp = [];
    const serviceProvider = 'ConsultaActivosFijosVisitante';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
    this.parametrosConsultaActivoFijoVisitante.tipoDocumentoVisitante = this.objetoEntrada.tipoIdVisitante;
    this.parametrosConsultaActivoFijoVisitante.numeroDocumentoVisitante = this.objetoFichaVisitante.numeroDocumento;
    const sub = this.global.postGenerico(url, this.parametrosConsultaActivoFijoVisitante).subscribe(
      (data: ConsultaActivoFijoVisitante[]) => {
        this.consultaActivoFijoVisitante = data;
        if (this.consultaActivoFijoVisitante.length === 1 &&
          this.consultaActivoFijoVisitante[0].numeroSerial === '' &&
          this.consultaActivoFijoVisitante[0].marca === '' &&
          this.consultaActivoFijoVisitante[0].numeroDeIngresos === 0) {
          if (this.banderaMensaje) {
            this.alertService.generateAlertError('El activo consultado no fue gestionado por el visitante seleccionado', 'Error');
          }
          this.banderaMensaje = true;
          this.consultaActivoFijoVisitante = [];
        } else {
          this.consultaActivoFijoVisitante.forEach(elemento => {
            const activo: ActivoFijoModel = new ActivoFijoModel('', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
            activo.descripcion = elemento.descripcion;
            activo.marca = elemento.marca;
            activo.observaciones = elemento.observaciones;
            activo.serialActivoFijo = elemento.numeroSerial;
            activo.idActivo = elemento.idActivoFijovisitante;
            activo.numeroIngresos = elemento.numeroDeIngresos;
            activo.fechaUltimoIngreso = elemento.fechaUltimoIngreso;
            activo.estado = elemento.estado;
            activo.clasificacion = 'PROPIO';
            activo.pantallaOrigen = ConstantesService.PANTALLA_INGRESO_SALIDA_VISITANTE_SALIDA;
            listaTemp.push(activo);
            if (elemento.estado == 'INGRESADO') {
              this.tieneActivosIngresados = true;
              this.ingresoActivo = true;
            }
          });
        }
        this.listaActivosPrincipal = listaTemp;
        this.spiner.hide();
      }, (err: any) => {
        this.cathException('No es posible realizar la consulta de activos fijos', err);
      }
    );
    this.subscription.push(sub);
  }

  /**
   * 
   */
  validarSalida() {

    this.validarAgendasDia();

  }

  /**
   * metodo de validaciòn de multiples agendas para el dìa
   * @author fromero
   */
  validarAgendasDia() {
    if (this.objetoFichaVisitante.listaVisitas.length > 1) {
      if (this.valdiarPerdidaStickeR()) {
        this.vermodal();
      }
    } else {
      if (this.valdiarPerdidaStickeR()) {
        this.registrarSalidaVisitante('Salida');
      }
    }
  }

  /**
   * Metodo que valida si  registra perdida sticker y observaciones
   * @author fromero
   */
  valdiarPerdidaStickeR() {
    if (this.objetoFichaVisitante.sticker) { // validaciòn observaciones y sticker
      if (!this.objetoFichaVisitante.observaciones || this.objetoFichaVisitante.observaciones === ''
        || this.objetoFichaVisitante.observaciones === ' ') {
        this.cathException('Por favor ingrese observaciones por pérdida de Sticker/Tarjeta');
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }



  /**
   * método para realizar petición de guardado de información al backend
   * 13/05/2019
   * @param tipoRegistro 
   * @author fromero
   */
  registrarSalidaVisitante(tipoRegistro: string) {

    this.spiner.show();
    this.validarActivosIngresadosFront();
    setTimeout(() => {
      this.objetoFichaVisitante.saleActivoFijo = !this.tieneActivosIngresados; // si tiene activos ingresados es false, si no tiene es true
      this.objetoFichaVisitante.tieneActivosIngresados = this.tieneActivosIngresados;
      this.objetoFichaVisitante.tipoRegistro = tipoRegistro;
      this.objetoFichaVisitante.sticker = !this.objetoFichaVisitante.sticker;
      const serviceProvider = 'RegistrarSalidaVisitante';
      const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);

      const sub = this.global.postGenerico(url, this.objetoFichaVisitante).subscribe(
        data => {
          this.alertService.generateAlertSuccess(data.mensaje, '');
          this.spiner.hide();
          this.registroFinalizado = true;
          this.regresarListaAgendas();
        }, err => {
          this.cathException('No fue posible registrar salida de visitante');
        }
      );
      this.subscription.push(sub);
    }, 1000);


  }

  // fromero
  // método que recibe los cambios en el model de fichaVisitante
  // 13/05/2019
  public handlerFichaVisitante(event) {

    this.objetoFichaVisitante = event;
    if (this.objetoFichaVisitante.sticker) { // valida si se selecciono la opcion de perdida sticker
      this.modalOptionsSalida.message = ConstantesService.MSJ_CONF_SAL_SIN_STICKER;
    }
  }

  // fromero:
  // método de prueba para inyectar un componente dentro del modal,
  // se envía componente y opciones de modal
  // 14/05/2019
  public vermodal() {
    const modalRef = this.modalService.open(RegistroSalidaModalComponent,
      { centered: true, windowClass: 'myCustomModalClass' });
    modalRef.componentInstance.InformacionVisitante = this.objetoFichaVisitante; // Objeto que se envìa al modal para ediciòn
    modalRef.result.then((result) => {
      this.handlerModal(result);
    });
  }

  // fromero:
  // método hanlder del modal de varias agendas
  // 14/05/2019
  public handlerModal(result) {
    if (result.respuesta) {
      if (result.accion != 'a') {
        if (result.accion !== 'Cancel') {
          this.registrarSalidaVisitante(result.accion);
        }
      }
    }
  }

  // fromero
  // método handler del modal de confirmación
  // 16 /05/2019
  getConfirmationModalResponse(event) {
    if (event[0]) {
      if (this.valdiarPerdidaStickeR()) {
        this.registrarSalidaVisitante(event[1]);
      }
    }
  }

  // 04520798001

  // fromero
  // handler de error
  // 12/05/2019
  public cathException(error, err?) {
    this.alertService.generateAlertError(error, ' ');
    this.spiner.hide();
  }

  handlerFiltroBusqueda(event) {
    this.spiner.show();
    this.parametrosConsultaActivoFijoVisitante.numeroSerial = event;
    this.consultarActivosFijos();
  }


  validarActivosIngresadosFront() {
    this.tieneActivosIngresados = false;
    this.listaActivosPrincipal.forEach(element => {
      if (element.estado == 'INGRESADO') {
        this.tieneActivosIngresados = true;
      }
    });

  }
}
